export default __webpack_public_path__ + "static/media/Rusty.99c5ad11.webp";